import {usePage} from "@inertiajs/react";
import {CallListPatient} from "@/lib/types/models.ts";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";

interface CallListDialogProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    patients: CallListPatient[];
}

export default function CallListDialog({
                                           isOpen,
                                           onOpenChange,
                                           patients,
                                       }: CallListDialogProps) {
    const {translations} = usePage().props as unknown as { translations: any };
    const t = translations.call_list_dialog;

    const formatTime = (isoString: string) => {
        const d = new Date(isoString);
        return d.toLocaleTimeString([], {hour: "2-digit", minute: "2-digit"});
    };


    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{t.title || "Lista za pozivanje"}</DialogTitle>
                </DialogHeader>

                <div className="space-y-2 mt-4">
                    {patients.length === 0 ? (
                        <div className="text-sm text-muted-foreground">
                            {t.messages.no_patients || "Nema pacijenata za ovaj termin."}
                        </div>
                    ) : (
                        patients.map((p) => (
                            <div
                                key={p.id}
                                className="flex justify-between items-center p-2 border-b last:border-b-0"
                            >
                                <div className="font-medium">{p.name}</div>
                                <div className="flex gap-4 text-sm text-muted-foreground">
                                    <span>{p.phone_number ?? "-"}</span>
                                    <span>{formatTime(p.appointment_at)}</span>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}